import { State, STATES } from 'util/types/states';
import { ErrorMessages } from 'forms/error-messages';
import * as z from 'zod';

export const createSchoolFormSchema = z.object({
  name: z.string().nonempty(ErrorMessages.Required),
  isHidden: z.boolean().default(false),
  websiteUrl: z
    .string()
    .regex(/^.*:\/\/.*$/, 'Include protocol (https:// or http://)')
    .nonempty(ErrorMessages.Required)
    .url(),
  streetAddress: z.string().nonempty(ErrorMessages.Required),
  city: z.string().nonempty(ErrorMessages.Required),
  state: z.nativeEnum(STATES as Record<number, State>),
  zipCode: z.string().regex(/^\d{5}$/, ErrorMessages.ZipCode.INVALID),
  domainName: z
    .string()
    .nonempty(ErrorMessages.Required)
    .regex(/^[^A-Z]*$/, 'Please enter a lowercase domain name')
    .regex(/^([a-z0-9-]+\.)+edu/, 'Please enter a .edu domain name'),
  aliases: z
    .array(
      z.object({
        value: z.string().nonempty(ErrorMessages.Required),
      }),
    )
    .optional(),
  slug: z.string().nonempty(ErrorMessages.Required),
  termsUrl: z
    .string()
    .url({ message: 'Enter a valid URL' })
    .nonempty(ErrorMessages.Required),
  termsDisplayName: z.string().nonempty(ErrorMessages.Required),
});

export type CreateSchoolForm = z.TypeOf<typeof createSchoolFormSchema>;
